import { useState } from "react";

export const useScroller = () => {
  const [scrollY, setScrollY] = useState(0);

  const scrollUpdate = (scrollTop: number | undefined) => {
    if (scrollTop) {
      setScrollY(scrollTop);
    }
  };

  return { scrollY, scrollUpdate };
};
